import {
    GET_WORD,
    UPDATE_WORD,
    SET_USER,
    SET_ORDER_HISTORY,
    SET_BRANCHES,
    SET_DELIVERY_SITES,
    SET_VALID_QUOTES,
    UPDATE_SELECTED_DELIVERY_SITE,
    UPDATE_SELECTED_BRANCH,
    GET_CUSTOMER_LIST,
    GET_SELECTED_CUSTOMER,
    GET_QLOAD_CUSTOMER_LIST,
    RESET_ORDER,
    UPDATE_ORDER_NUMBER,
    UPDATE_SPECIAL_INSTRUCTIONS,
    UPDATE_REQ_DELIVERY_DATE,
    UPDATE_WEIGHT,
    SET_PRODUCT_LIST,
    SET_PRODUCT_GROUPS,
    UPDATE_PRODUCT_LIST,
    SET_MIN_AND_MAX_ORDER_WEIGHT,
    SET_CUSTOMER_SURCHARGES_LIST,
    SET_SELECTED_PRODUCTS_LIST,
    SET_ORDER_SUMMARY_RESULT,
    SET_PRODUCT_PRICE_PREVIEW,
    FORCE_USER_BACK,
    UPDATE_NMBS_REFERENCE,
    UPDATE_FPMCCANN_ORDER_NUMBER,
    IS_LOADING,
    LOGGING_IN_ERROR,
    SAVED_USERNAME,
    POPULATE_FROM_BASKET,
    DELETE_BASKET,
    SET_ORDER_ERROR,
    SET_ORDER_SUMMARY_ERROR,
    NOTIFICATION_TEXT,
    RETURN_PALLETS,
    TILE_INTEREST,
    UPDATE_LORRYLOAD,
    SET_SEARCH_TEXT,
    UPDATE_SELECTED_QUOTE,
    SET_PRODUCT_LOADING,
    RESET_PRODUCT_BASKET
} from './types';

import { authController, dataController, orderProcessController } from '../api/api.js';
import authService from '../../../components/api-authorization/AuthorizeService';
import history from '../../../history.js';
import { isEmpty } from "lodash";

const sortProductList = (list, filtervalue, orderAsc) => {
    // sort is handled differently depending on the datatype
    if (filtervalue === "productCode" || filtervalue === "productName") {
        return orderAsc == true
            ? [...list].sort((a, b) => b[filtervalue].localeCompare(a[filtervalue]))
            : [...list].sort((a, b) => a[filtervalue].localeCompare(b[filtervalue]));
    }

    return orderAsc == true
        ? [...list].sort((a, b) => (b[filtervalue] - a[filtervalue]))
        : [...list].sort((a, b) => (a[filtervalue] - b[filtervalue]));
};


export const loadingPage = (value) => async dispatch => {

    dispatch({ type: IS_LOADING, payload: value })

}

export const productLoading = (value) => async dispatch => {
    dispatch({type: SET_PRODUCT_LOADING, payload: value});
}


export const updateErrorLoggingIn = (value, message) => async dispatch => {

    dispatch({ type: LOGGING_IN_ERROR, payload: { error: value, errorMessage: message } });
}

export const saveLoggedUsername = (value) => async dispatch => {

    dispatch({ type: SAVED_USERNAME, payload: value });
}


export const getWord = () => async dispatch => {

    dispatch({ type: GET_WORD, payload: 'testtt' });
};

export const updateWord = (value) => async dispatch => {

    dispatch({ type: UPDATE_WORD, payload: value });
};

export const resetOrder = () => async dispatch => {

    dispatch({ type: RESET_ORDER });
};


export const resetOrderSummary = () => async dispatch => {

    dispatch({ type: SET_ORDER_SUMMARY_RESULT, payload: [] });

};


export const setUser = (user) => async dispatch => {

    dispatch({ type: SET_USER, payload: user });
};




export const displayNotification = () => async dispatch => {

    try {

        const token = await authService.getAccessToken();

        const response = await fetch(dataController + 'notificationMessage', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then((response) => {
                if (response.status === 401) {
                    throw new Error("Unauthorised request");
                }
                return response;
            })
            .then(res => res.json())
            .catch((error) => {
            });

        if (response.isSuccess === false) {

            const returnUrl = '/';
            const state = { returnUrl };
            await authService.signOut(state);

        }
        else {

            dispatch({ type: NOTIFICATION_TEXT, payload: response.message });
        }

    } catch (e) {

    }
};






export const updateSelectedDeliverySite = (deliverySiteId) => async dispatch => {

    dispatch({ type: UPDATE_SELECTED_DELIVERY_SITE, payload: deliverySiteId });
};

export const updateSelectedQuote = (quoteId) => async dispatch => {

    console.log('updateSelectedQuote');
    dispatch({ type: UPDATE_SELECTED_QUOTE, payload: quoteId });
};

export const updateProductListByQuote = (quoteId) => async dispatch => {

    let errorFetching = false;
    const token = await authService.getAccessToken();
    
    const response = await fetch(dataController + 'productList/' + quoteId, {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;

        });

    if (errorFetching === true) {

        const returnUrl = '/';
        const state = { returnUrl };

        await authService.signOut(state);

    }
    else {

        if (response.error === false) {
            const sortedProductList = sortProductList(response.productList, "productCode", false);
            dispatch({ type: SET_PRODUCT_LIST, payload: sortedProductList });
            dispatch({ type: SET_PRODUCT_GROUPS, payload: response.productGroupList });
        }

        else {
            //ERROR OCCURRED

            dispatch({ type: SET_ORDER_ERROR, payload: response.errorMessage });
        }

    }
}

export const updateDeliverySiteList = () => async dispatch => {

    console.log("updateDeliverySite")
    let errorFetching = false;
    const token = await authService.getAccessToken();

    const response = await fetch(dataController + 'deliverySiteList/', {
        method: 'get',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;

        });

    if (errorFetching === true) {

        const returnUrl = '/';
        const state = { returnUrl };

        await authService.signOut(state);

    }
    else {

        if (response.error === false) {
            dispatch({ type: SET_DELIVERY_SITES, payload: response.deliverySiteList });
        }

        else {
            //ERROR OCCURRED

            dispatch({ type: SET_ORDER_ERROR, payload: response.errorMessage });
        }

    }
}

export const updateSelectedBranch = (branchId) => async dispatch => {

    dispatch({ type: UPDATE_SELECTED_BRANCH, payload: branchId });

};

export const getRecentOrders = (username, userHasBeenSet) => async dispatch => {

    const token = await authService.getAccessToken();

    //const token = null;

    var errorFetching = false;

    const response = await fetch(dataController + 'getrecentorders/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            Username: username,
            UserHasBeenSet: userHasBeenSet
        })
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;

        });


    if (errorFetching === true) {

        const returnUrl = '/';
        const state = { returnUrl };
        await authService.signOut(state);

    }
    else {

        if (response.error === true) {

        }
        else {
            if (userHasBeenSet === false) {
                dispatch({ type: SET_USER, payload: response.user });
            }
        }


        dispatch({ type: SET_ORDER_HISTORY, payload: response.orders });
    }
};









export const populateUserDetails = (username) => async dispatch => {

    const token = await authService.getAccessToken();
    var errorFetching = false;


    const response = await fetch(dataController + 'findUserDetails/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            Username: username
        })
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;
        });

    if (errorFetching === true) {

        const returnUrl = '/';
        const state = { returnUrl };

        await authService.signOut(state);

    }
    else {
        // return user viewmodel for updating details
        dispatch({ type: SET_USER, payload: response });
    }
}














export const populateOrderPage = (username, userHasBeenSet) => async dispatch => {

    const token = await authService.getAccessToken();

    var errorFetching = false;

    //const response = await fetch('https://localhost:44359/api/data/initialiseorderpage/', {

    const response = await fetch(dataController + 'initialiseorderpage/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            Username: username,
            UserHasBeenSet: userHasBeenSet
        })
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;

        });

    if (errorFetching === true) {

        const returnUrl = '/';
        const state = { returnUrl };

        await authService.signOut(state);

    }
    else {

        if (response.error === false) {

            if (userHasBeenSet === false) {
                dispatch({ type: SET_USER, payload: response.user });
            }

            //set to 1st on list
            if (!isEmpty(response.deliverySiteList)) {
                dispatch({ type: UPDATE_SELECTED_DELIVERY_SITE, payload: response.deliverySiteList[0].id });

            }

            //set to 1st on list
            if (!isEmpty(response.branchList)) {
                dispatch({ type: UPDATE_SELECTED_BRANCH, payload: response.branchList[0].id });

                // update to use the nmbs ref on load
                if (response.branchList[0].nmbsReference !== "") {
                    dispatch({ type: UPDATE_NMBS_REFERENCE, payload: response.branchList[0].nmbsReference });
                }

            }
            else {
                //if no branch, create a state to reflect this and do not show branch dropdown on screen
            }


            dispatch({ type: SET_BRANCHES, payload: response.branchList });
            dispatch({ type: SET_DELIVERY_SITES, payload: response.deliverySiteList });
            dispatch({ type: SET_VALID_QUOTES, payload: response.quoteList });
            const sortedProductList = sortProductList(response.productList, "productCode", false);
            dispatch({ type: SET_PRODUCT_LIST, payload: sortedProductList });
            dispatch({ type: SET_PRODUCT_GROUPS, payload: response.productGroupList });
            dispatch({ type: SET_MIN_AND_MAX_ORDER_WEIGHT, payload: { minWeight: response.minOrderWeight, maxWeight: response.maxOrderWeight } });
            dispatch({ type: SET_CUSTOMER_SURCHARGES_LIST, payload: response.customerSurcharges });
        }

        else {
            //ERROR OCCURRED

            dispatch({ type: SET_ORDER_ERROR, payload: response.errorMessage });
        }


    }
};


export const getCustomerList = (value) => async dispatch => {

    const token = await authService.getAccessToken();

    const response = await fetch(dataController + 'getcustomerist/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
        })
    })
        .then(res => res.json())
        .catch();


    dispatch({ type: GET_CUSTOMER_LIST, payload: response });
};

export const getSelectedCustomer = (cus) => async dispatch => {

    dispatch({ type: GET_SELECTED_CUSTOMER, payload: cus });

    //console.log(cus);
};




export const getQloadCustomerList = (value) => async dispatch => {

    const token = await authService.getAccessToken();
    const response = await fetch(dataController + 'getqloadcustomerlist/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
        })
    })
        .then(res => res.json())
        .catch();


    dispatch({ type: GET_QLOAD_CUSTOMER_LIST, payload: response });
};

export const updateCusNumber = (value) => async dispatch => {

    dispatch({ type: UPDATE_ORDER_NUMBER, payload: value });
};

export const updateSpecialInstructions = (value) => async dispatch => {

    dispatch({ type: UPDATE_SPECIAL_INSTRUCTIONS, payload: value });
};

export const updateReqDelDate = (value) => async dispatch => {

    dispatch({ type: UPDATE_REQ_DELIVERY_DATE, payload: value });
};

export const updateWeight = () => async dispatch => {

    dispatch({ type: UPDATE_WEIGHT, payload: 10 });
};

export const resetWeight = () => async dispatch => {

    dispatch({ type: UPDATE_WEIGHT, payload: 0 });
};

export const updateLorryLoad = () => async dispatch => {

    dispatch({ type: UPDATE_LORRYLOAD, payload: 10 });
};

export const UpdateNMBSReference = (ref) => async dispatch => {

    dispatch({ type: UPDATE_NMBS_REFERENCE, payload: ref });
};



export const updateProductList = (value, productId, list, filtervalue, orderAsc, units = 0) => async dispatch => {

    var overallWeight = 0;
    var truckLoad = 0;

    for (var i in list) {
        if (list[i].productId == productId) {
            list[i].packs = value;
            list[i].units = units;

            list[i].quantity = (list[i].packSize * value) + units;

            var totWeight = list[i].quantity * list[i].weight.toFixed(4);
            totWeight = totWeight.toFixed(4);

            list[i].totalWeight = totWeight;

            var xtotWeight = list[i].totalWeight;
            overallWeight = +overallWeight + +xtotWeight;

            var cadebyLorryWeight = 26; //24
            truckLoad = parseFloat(overallWeight) / cadebyLorryWeight

        }
        else {
            var xtotWeight = list[i].totalWeight;
            overallWeight = +overallWeight + +xtotWeight;

            var cadebyLorryWeight = 26; //24
            truckLoad = parseFloat(overallWeight) / cadebyLorryWeight
        }
    }



    let newList = sortProductList(list, filtervalue, orderAsc);

    dispatch({ type: UPDATE_PRODUCT_LIST, payload: newList });

    dispatch({ type: UPDATE_WEIGHT, payload: { weight: overallWeight.toFixed(4) } });

    dispatch({ type: UPDATE_LORRYLOAD, payload: { truckLoad: truckLoad.toFixed(2) } });
};

export const submitOrderPage = (productList, surchargeNeeded, surchargePercentage) => async dispatch => {

    dispatch({ type: SET_SELECTED_PRODUCTS_LIST, payload: { productList: productList, surchargeNeeded: surchargeNeeded, surchargePercentage: surchargePercentage } });

};






export const getOrderSummary = (customerId, branchId, deliverySiteId, quoteId, totalOrderWeight, surchargeNeeded, surchargePercentage, selectedProducts, cusOrderNumber, reqDelDate, specialInstructions) => async dispatch => {

    const token = await authService.getAccessToken();

    var errorFetching = false;


    //for (let i = 0; i < selectedProducts.length; i++) {

    //    selectedProducts[i].packs = parseInt(selectedProducts[i].packs);
    //    selectedProducts[i].totalWeight = parseFloat(selectedProducts[i].totalWeight);
    //}

    const response = await fetch(orderProcessController + 'getordersummary/', {
        method: 'post',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
            CustomerId: parseInt(customerId),
            BranchId: parseInt(branchId),
            DeliverySiteId: parseInt(deliverySiteId),
            QuoteId: parseInt(quoteId),
            TotalOrderWeight: parseFloat(totalOrderWeight),
            SurchargeNeeded: surchargeNeeded,
            SurchargePercentage: parseInt(surchargePercentage),
            SelectedProducts: selectedProducts,
            CustomerOrderNumber: cusOrderNumber,
            CustomerDeliveryDateString: reqDelDate,
            CustomerSpecialInstructions: specialInstructions

        })
    })
        .then((response) => {
            if (response.status === 401) {
                throw new Error("Unauthorised request");
            }
            return response;
        })
        .then(res => res.json())
        .catch((error) => {

            //sign out and redirect to login page
            errorFetching = true;

        });


    if (response.error === false) {
        dispatch({ type: SET_ORDER_SUMMARY_RESULT, payload: response });
    }
    else {
        dispatch({ type: SET_ORDER_SUMMARY_ERROR, payload: response.errorMessage });
    }




    if (errorFetching === true) {

        //const returnUrl = '/';
        //const state = { returnUrl };
        //await authService.signOut(state);

    }
    else {

        //if (userHasBeenSet === false) {
        //    dispatch({ type: SET_USER, payload: response.user });
        //}


        //dispatch({ type: SET_ORDER_HISTORY, payload: response.orders });
    }




};

// Preview-only: same pricing logic as getOrderSummary via a different endpoint, but no basket write.
export const getProductPricePreview = (customerId, branchId, deliverySiteId, quoteId, totalOrderWeight, surchargeNeeded, surchargePercentage, selectedProducts) => async dispatch => {

    if (!customerId || !deliverySiteId) {
        // not enough info yet to price anything - leave any existing preview as-is
        return;
    }

    const token = await authService.getAccessToken();

    let response;

    try {
        response = await fetch(orderProcessController + 'getproductpricepreview/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                CustomerId: parseInt(customerId),
                BranchId: parseInt(branchId),
                DeliverySiteId: parseInt(deliverySiteId),
                QuoteId: parseInt(quoteId),
                TotalOrderWeight: parseFloat(totalOrderWeight),
                SurchargeNeeded: surchargeNeeded,
                SurchargePercentage: parseInt(surchargePercentage),
                SelectedProducts: selectedProducts,
                CustomerOrderNumber: '',
                CustomerDeliveryDateString: '',
                CustomerSpecialInstructions: ''
            })
        }).then(res => res.json());
    } catch (error) {
        // preview is best-effort - silently skip on network/parse errors
        return;
    }

    if (!response || response.error) {
        return;
    }

    const pricePreview = {};

    (response.orderItemsList || []).concat(response.deliveryItemsList || []).forEach(item => {
        pricePreview[item.productId] = { unitPrice: item.unitPrice, lineTotal: item.lineTotal };
    });

    dispatch({ type: SET_PRODUCT_PRICE_PREVIEW, payload: pricePreview });
};



export const InsertOrder =(summaryModel, customerSpecInstructions, requestedDelDate, customerOrderNumber, branchId, deliverysiteId, totalOrderWeight, nmbsReference, orderPaid, returnPallets, tileInterest, quoteId, paymentIntentId) => async dispatch => {

    try {

        const token = await authService.getAccessToken();

        var errorFetching = false;

        const response = await fetch(orderProcessController + 'insertorder/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                ReturnViewModel: summaryModel,
                CustomerSpecialInstructions: customerSpecInstructions,
                RequestedDeliveryDateString: requestedDelDate,
                CustomerOrderNumber: customerOrderNumber,
                BranchId: parseInt(branchId),
                DeliverySiteId: parseInt(deliverysiteId),
                QuoteId: parseInt(quoteId),
                TotalOrderWeight: parseFloat(totalOrderWeight),
                NMBSReference: nmbsReference,
                OrderPaid: orderPaid,
                ReturnPallets: returnPallets,
                TileInterest: tileInterest,
                StripePaymentIntentId: paymentIntentId
            })
        })
            .then((response) => {
                if (response.status === 401) {
                    throw new Error("Unauthorised request");
                }
                return response;
            })
            .then(res => res.json())
            .catch((error) => {

                //sign out and redirect to login page
                errorFetching = true;

            });


        // order has been successfully saved

        if (response.isSuccess === true) {
            await dispatch({ type: UPDATE_FPMCCANN_ORDER_NUMBER, payload: response.fpMcCann_OrderNumber });
        }
        else {

        }


    } catch (e) {

    }
}




export const updateForceUserBack = (boolresult) => async dispatch => {

    dispatch({ type: FORCE_USER_BACK, payload: boolresult });
};



export const populateOrderFromBasket = (data) => async dispatch => {

    dispatch({ type: POPULATE_FROM_BASKET, payload: data });

};

export const deleteBasket = () => async dispatch => {


    try {
        const token = await authService.getAccessToken();

        const response = await fetch('api/data/deleteuserbasket/', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        })
            .then(res => res.json())
            .catch();
    }
    catch (e) {

    }


    dispatch({ type: DELETE_BASKET });
}

export const resetProductBasket = () => async dispatch => {

    dispatch({ type: RESET_PRODUCT_BASKET });

};


export const submitCustomerEnquiry = (message, name, phone, email) => async dispatch => {

    try {

        const token = await authService.getAccessToken();

        const response = await fetch(dataController + 'submitEnquiry', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({
                Email: email,
                PhoneNumber: phone,
                Message: message,
                CustomerName: name
            })
        })
            .then((response) => {
                if (response.status === 401) {
                    throw new Error("Unauthorised request");
                }
                return response;
            })
            .then(res => res.json())
            .catch((error) => {
            });


        return response;



    } catch (e) {

    }

};


export const isReturnPalletsRequired = (data) => async dispatch => {
    dispatch({ type: RETURN_PALLETS, payload: data });
};

export const isInterestedInTiles = (data) => async dispatch => {
    dispatch({ type: TILE_INTEREST, payload: data });
};

export const updateSearchText = (ref) => async dispatch => {

    dispatch({ type: SET_SEARCH_TEXT, payload: ref });
};